import { ValidationRules } from "aurelia-validation";
import { ContactPhone } from "./contact-phone";

export class Contact {

    constructor() {
    }

    id: number;
    carrierId: number;
    name: string;
    title: string;
    verified: boolean;
    email: string;
    mills: string;  //comma-delimited list of mills that this contact is associated with
    contactTypeIds: Array<Number> = [];
    contactType: string;
    city: string;
    state: string;
    receiveAccountingReports: boolean = undefined;
    receiveDispatchReports: boolean = undefined;
    phones: Array<ContactPhone> = [];
    lastVerified: Date;
    lastVerifiedBy: string;
}

ValidationRules.customRule(
    'hasContactTypes',
    (value, obj) => !!(obj.contactTypeIds && obj.contactTypeIds.length),
    `\${$displayName} must be specified.`
);

ValidationRules
    .ensure((m: Contact) => m.name).required()
    .ensure((m: Contact) => m.title).required()
    .ensure((m: Contact) => m.email).required().email()
    .ensure((m: Contact) => m.contactTypeIds).satisfiesRule("hasContactTypes")
    .ensure((m: Contact) => m.phones).required()
    .on(Contact);
